// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__2DER-","Less":"BuildControl_Less__1l4Bz","More":"BuildControl_More__1vNlC","Label":"BuildControl_Label__3Ud0T"};